import React, { useState } from "react";
import { useEffect } from "react";
import Footer from "../Footer/Footer";
import QuestionHeader from "./QuestionHeader";
import QuestionNav from "./QuestionNav";
import "./questions.css";




type AccordionItem = {
  id: number;
  question: string;
  answer: string;
};





const items: AccordionItem[] = [
  {
    id: 0,
    question: "Why use TAG?",
    answer:
      "TAG can help you and your organisation identify, assess, manage and mitigate risk associated with human behaviour.  We have decades of experience in understanding, conceptualising and working with a range of such risks.   As psychologists, we take a nuanced and individualised approach to understanding the risk associated with human behaviour, in addition to being able to manage such risks from the broader perspective (e.g., considering organisational, cultural, systemic, community, team factors).  ",
  },
  {
    id: 1,
    question: "Why psychologists?",
    answer:
      "Psychologists are experts in human behaviour and mental health and we use psychometric testing unlike any other professional discipline.  ",
  },
  {
    id: 2,
    question: "Why use psychometric testing?",
    answer:
      "Psychometric testing is a structured, scientific process that provides objective and evidence based assessment of human functioning.  As it is standardised, it allows comparison of an individual to the wider population.  Psychologists are the only profession that can use such testing.  Psychometric testing can assess for response bias, malingering and deception, in addition to a range of other human attributes, such as intelligence, personality, mental health, attitudes, neurocognitive functioning etc.  Using psychometric testing provides an added layer of confidence over and above relying solely on an individual’s self-report. ",
  },
  {
    id: 3,
    question: "Why use forensic psychologists?",
    answer:
      "Forensic psychologists are experts working at the intersection of Psychology and the Law.  We have expertise in assessing and managing the risks associated with human behaviour. Forensic psychologists provide expert evidence and forensic analysis and we are used to writing expert reports for agencies, including the Courts.   ",
  },
  {
    id: 4,
    question: "Why is proactive risk management also important?",
    answer:
      "Traditionally, risk management has been a reactive exercise however, it is in everyone’s interest that a proactive approach to risk management occurs.  This will save money, time, resources and also work to prevent acts causing harm from occurring.  Organisations benefit from anticipating risk, understanding and monitoring behaviour and relationships within the workplace, and planning for risk mitigation in a proactive manner.  ",
  },
  {
    id: 5,
    question: "What is the benefit of a comprehensive approach to risk? ",
    answer: "TAG can provide the range of services needed in risk management associated with human behaviour from assessment through to intervention and management.  We take a comprehensive, wide lens approach to understanding such risks, taking into account individuals, relationships, behaviour and processes, improving effectiveness.  ",
  },
  {
    id: 6,
    question: "What if we don’t just need a psychologist? ",
    answer:"TAG works with a multidisciplinary team, bringing in other experts as required, guaranteeing an informed, sensitive and responsive approach.   ",
  },
  {
    id: 7,
    question: "How do I get more information or make a referral? ",
    answer:"Please contact us at admin@threatadvisorygroup.com and we will be in touch to discuss your unique needs and how we can assist.  ",
  },
];

const Question: React.FC = () => {
  const [activeId, setActiveId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setActiveId(activeId === id ? null : id);
  };

  useEffect(() => {
    const faders = document.querySelectorAll('.fade-in');
  
    const appearOptions = {
      threshold: 0.2, // kicsit előbb figyel
      rootMargin: "0px 0px -200px 0px" // előbb elkezdi tölteni
    };
  
    const appearOnScroll = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('show');
        observer.unobserve(entry.target);
      });
    }, appearOptions);
  
    faders.forEach((fader, index) => {
      const el = fader as HTMLElement;
      el.style.transitionDelay = `${index * 0.03}s`; // kicsit lassabb chain effekt
      appearOnScroll.observe(el);
    });
  }, []);

  return (
    <>
    <QuestionNav/>
    <QuestionHeader/>
    <section className="accordion-container fade-in">
      {items.map((item) => (
        <div key={item.id} className="accordion-item ">
          <button
            className={`accordion-header ${
              activeId === item.id ? "active" : ""
            }`}
            onClick={() => toggle(item.id)}
          >
            {item.question}
            <span className="accordion-icon">
              {activeId === item.id ? "−" : "+"}
            </span>
          </button>
          <div
            className={`accordion-body ${
              activeId === item.id ? "open" : ""
            }`}
          >
            <p>{item.answer}</p>
          </div>
        </div>
      ))}
    </section>
    <Footer/>
    </>
  );
};

export default Question;
